import { TimelineTimeframes, Timestamp } from '@griply/types';
import { startOfMonth, startOfQuarter, startOfYear } from 'date-fns';

const referenceDateFunc: Record<
  TimelineTimeframes,
  (date: Timestamp) => Timestamp
> = {
  [TimelineTimeframes.Month]: startOfMonth,
  [TimelineTimeframes.Quarter]: startOfQuarter,
  [TimelineTimeframes.Year]: startOfYear,
  [TimelineTimeframes.FiveYears]: startOfYear,
};

export const getRoadmapReferenceDate = (
  timeframe: TimelineTimeframes,
  today: Timestamp,
): Timestamp => referenceDateFunc[timeframe](today);
